var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownloadFileImage = function SvgDownloadFileImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DCD1B9",
    fillRule: "evenodd",
    d: "m26.285 10.287-8.002-8.002H8.113a2.4 2.4 0 0 0-2.4 2.4v22.629a2.4 2.4 0 0 0 2.4 2.4h15.772a2.4 2.4 0 0 0 2.4-2.4z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B9A476",
    d: "M18.283 10.285v-8l8 8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B9A476",
    fillRule: "evenodd",
    d: "M9.875 16.5c0-.725.588-1.312 1.313-1.312h9.625c.724 0 1.312.587 1.312 1.312v7c0 .725-.588 1.313-1.312 1.313h-9.625A1.31 1.31 0 0 1 9.875 23.5zm.875 5.869V23.5c0 .242.196.438.438.438h9.625a.44.44 0 0 0 .437-.438v-1.131l-1.569-1.57a.875.875 0 0 0-1.237 0l-.513.514.566.565a.438.438 0 0 1-.619.619l-3.01-3.01a.875.875 0 0 0-1.237 0zm5.906-4.556a.656.656 0 1 1 1.313 0 .656.656 0 0 1-1.313 0",
    clipRule: "evenodd"
  })));
};
export default SvgDownloadFileImage;